import Report from "./Report";
import FieldSet from "./FieldSet";
import ReportParameters from "./ReportParameters";
export default class Parameter {
    // Nom du Paramètre qui sera la clé du dictionnaire
    public Name: string;

    // Label affichées dans le parametrage
    public Label: string;
    
    // Type du Parameter (CheckBox, ComboBox, GridPanel,...)
    public Type: string;
        
    // Texte affiché lorsqu'il n'y a pas de données à afficher
    public EmptyText: string;
    
    // Valeur Sélectionné qui sera la valeur du dictionnaire
    public Selected: string;
    
    // Option en plus pour certains paramétrages
    public Option: object;
    
    // Actions efféctués lors d'un évenement sur un Parameter
    public Listeners: Array<{ key: string, value: string }>;

    public constructor(Name = '', Label = '', Type = 'Ghost', EmptyText = '', Selected = '', Option = {}, Listeners = []) {
        this.Name = Name;
        this.Label = Label;
        this.Type = Type;
        this.EmptyText = EmptyText;
        this.Selected = Selected;
        this.Option = Option;
        this.Listeners = Listeners;
    }
        
    //#region Méthode statique

    // Registre pour stocker les sous-classes
    private static subclasses: typeof Parameter[] = [];

    // Enregistrer une sous-classe
    static registerSubclass(subclass: typeof Parameter): void {
        this.subclasses.push(subclass);
    }

    // Méthode pour récupérer toutes les sous-classes
    static getSubclasses(): typeof Parameter[] {
        return this.subclasses;
    }

    //#endregion

    //#region ReportEditor

    /**
     * Créer des Parameters Temporaire
     * @param fieldSetIndex 
     */
    public createGhost(reportParameters: ReportParameters, fieldSetIndex: number){
        if(fieldSetIndex != undefined){
            for(let x = reportParameters.FieldSets[fieldSetIndex].Parameters.filter(u => u.Type != 'Hidden').length; x > 0; x--){
                reportParameters.FieldSets[fieldSetIndex].Parameters.splice(x, 0, new Parameter())
            }

            reportParameters.FieldSets[fieldSetIndex].Parameters.unshift(new Parameter())
        }
    }

    /**
     * Supprime les Parameter Temporaire
     * @param report 
     */
    public deleteGhost(reportParameters: ReportParameters){
        // Cherche les FieldSet qui a des GhostParameters
        let findFieldSets : FieldSet[] = reportParameters.FieldSets.filter(u => u.Parameters.find(x => {
            if(x instanceof Parameter){
                return (x as Parameter).equalsParameter();
            }
        }));

        findFieldSets.forEach(u => {
            // Cherche les GhostParameters
            u.Parameters.filter(z => { 
                if(z instanceof Parameter){
                    return z.equalsParameter();
                }
            }).forEach(y => {
                // Supprimer les Ghost Parameters
                u.Parameters.splice(u.Parameters.indexOf(y), 1)
            })
        })
    }

    public replaceGhost(reportParameters: ReportParameters, fieldSetIndex: number){
        this.deleteGhost(reportParameters);
        this.createGhost(reportParameters, fieldSetIndex);
    }

    public save(reportParameters: ReportParameters, selectedFieldSetIndex: number, selectedParameterIndex: number){
        console.log("y a peut etre")
        if(selectedFieldSetIndex == -1 && selectedParameterIndex == -1 && reportParameters.FieldSets.find(u => u.Parameters.find(x => x instanceof Parameter && (x as Parameter).equalsParameter()))){
            console.log("y a un truc la")
        } else {
            console.log("y a R")
            console.log("y a R : ", reportParameters)
            console.log("y a R - selectedFieldSetIndex : ", selectedFieldSetIndex)
            console.log("y a R - selectedParameterIndex :", selectedParameterIndex)
            reportParameters.FieldSets[selectedFieldSetIndex].Parameters.splice(selectedParameterIndex, 0, this);
            this.deleteGhost(reportParameters);
        }
    }

    //#endregion

    public HasValue() : boolean {
        return true;
    }

    public getClassName() {
        return "Parameter";
    }

    public fromXml(xml: string){
        if(xml){
            let parser = new DOMParser();
            let xmlDoc = parser.parseFromString(xml, "application/xml");

            let xmlParameter: Element = xmlDoc.querySelector('Parameter');
            if(xmlParameter != null){
                this.Name = xmlParameter.getAttribute('Name') || '';
                this.Label = xmlParameter.getAttribute('Label') || '';
                this.Type = xmlParameter.getAttribute('Type') || '';
                this.EmptyText = xmlParameter.getAttribute('EmptyText') || '';
            }
        }

        return this;
    }

    public equalsParameter(other: Parameter = new Parameter()): boolean{
        return (this.Name === other.Name 
        && this.Label === other.Label
        && this.Type === other.Type
        && this.EmptyText === other.EmptyText
        && this.Selected === other.Selected);
    }

    /**
     * 
     * @returns Propriété filtrées pour la création d'un objet Parameter
     */
    public getProperties(): Array<[string, any]>{
        return Object.entries(this).filter(([key]) => 
            this.keysToFilter.includes(key) )
    }

    /**
     * Créations des clé pour filtrer les propriété de Parameter
     */
    public keysToFilter: string[] =  [''];

    public create(): Parameter{
        return new Parameter(this.Name, this.Label, this.Type,this.EmptyText, this.Selected, this.Option, this.Listeners)
    }
}